import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { MaterialModule } from "src/app/material.module";
import { SharedModule } from "src/app/shared.module";
import { UserSettingsComponent } from "./user-settings.component";
import { UserSettingsInputsModule } from "../../user-settings-inputs/user-settings-inputs.component.module";

@NgModule({
    imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    MaterialModule,
    SharedModule,
    UserSettingsInputsModule
],
    declarations: [UserSettingsComponent],
    exports: [UserSettingsComponent]
})
export class UserSettingsModule {}